import React from 'react';
import {PolIcon} from "components/PolIcon/policon";
import PolButton from "v4/components/ui/PolButton/PolButton";
import PolPopup from "v4/components/ui/PolPopup/PolPopup";
import useCreateCoreLink from "v4/hooks/useCreateCoreLink";
import useToggle from "v4/hooks/useToggle";
import useNotification from "v4/hooks/useNotification";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import './MicrosoftGraphConnection.scss';

export default function MicrosoftGraphConnection({url, tenantId}) {
    const {t} = usePolTranslation();
    const [isOpen, toggleOpen] = useToggle();
    const {addSuccessNotification, addErrorNotification} = useNotification();
    const coreLink = useCreateCoreLink('admin/microsoft-graph/outlook');

    const copyLink = () => {
        navigator.clipboard.writeText(url)
            .then(() => addSuccessNotification(t('link_copied')))
            .catch(() => addErrorNotification(t('copy_link_error')));
    }

    return (
        <>
            <PolButton onClick={() => toggleOpen()}>{t('microsoft_graph_connection')}</PolButton>
            <PolPopup isOpen={isOpen}
                      closePopup={toggleOpen}
                      title="microsoft_graph_connection">
                <div className="microsoft-graph-connection">
                    <section className="microsoft-graph-connection__section">
                        <p className="microsoft-graph-connection__title">{t('microsoft_graph_new_configuration')}</p>
                        <p>{t('core_moved_config')}</p>
                        <a href={coreLink}
                           target="_blank"
                           rel="noopener noreferrer"
                           className="btn btn-primary btn-full">
                            {t('microsoft_graph_open_core_admin')}
                        </a>
                    </section>

                    <section className="microsoft-graph-connection__section microsoft-graph-connection__section--legacy">
                        <p className="microsoft-graph-connection__title">{t('microsoft_graph_legacy_title')}</p>
                        <p className="microsoft-graph-connection__warning">
                            <PolIcon icon="warning"/> {t('microsoft_graph_legacy_warning')}
                        </p>
                        <p className="microsoft-graph-connection__meta">TenantId : {tenantId}</p>
                        <PolButton className="btn-danger" onClick={copyLink}>
                            {t('microsoft_graph_copy_legacy_link')}
                        </PolButton>
                    </section>
                </div>
            </PolPopup>
        </>
    )
}
